import { render, staticRenderFns } from "./CommonAvatar.vue?vue&type=template&id=55df8816&"
import script from "./CommonAvatar.vue?vue&type=script&lang=js&"
export * from "./CommonAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports